/**
 * Mobile Placeholder Component
 * 
 * A simple placeholder component for mobile pages that haven't been implemented yet.
 * Shows a "coming soon" message with a link back to the mobile home.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import MobileLayout from '../../pages/mobile/MobileLayout';

/**
 * Mobile Placeholder Component
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.message - Message to display
 * @param {string} props.icon - FontAwesome icon class
 * @returns {JSX.Element} Mobile placeholder page
 */
const MobilePlaceholder = ({ title, message, icon = 'fas fa-clock' }) => {
  return (
    <MobileLayout title={title} showBackButton={true}>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '60vh', 
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{ 
          fontSize: '48px', 
          color: '#fff', 
          marginBottom: '20px' 
        }}>
          {icon === 'daire-icon' ? (
            <img src="/assets/img/daire/daire-logo-icon.png" alt="Daire AI" className="daire-icon" style={{ width: '48px', height: '48px' }} />
          ) : (
            <i className={icon}></i>
          )}
        </div>
        
        <h2 style={{ 
          fontSize: '24px', 
          color: '#fff', 
          marginBottom: '12px' 
        }}>
          {title}
        </h2>
        
        <p style={{ 
          fontSize: '16px', 
          color: '#fff', 
          marginBottom: '32px',
          lineHeight: '1.5'
        }}>
          {message || 'This mobile page is coming soon! We\'re working hard to bring you a great mobile experience.'}
        </p>
        
        <Link 
          to="/mobile" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: '#1976d2',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: '500',
            transition: 'all 0.2s ease'
          }}
        >
          <i className="fas fa-home"></i>
          Back to Home
        </Link>
      </div>
    </MobileLayout>
  );
};

export default MobilePlaceholder; 